module.exports = "---\ntitle: \"小记\"\ntime: \"2024-09-24\"\n---\n\n“小记”与其称作博客，不如叫做朋友圈更为贴切。大篇文章之外，偶尔的所思所想也会及时在此记录，欢迎翻阅。\n";